import { render, staticRenderFns } from "./Administrators.vue?vue&type=template&id=12df148c&scoped=true"
import script from "./Administrators.vue?vue&type=script&lang=js"
export * from "./Administrators.vue?vue&type=script&lang=js"
import style0 from "./Administrators.vue?vue&type=style&index=0&id=12df148c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12df148c",
  null
  
)

export default component.exports